export let getServerErrorMessage = function (err) {
  // Check if server response contains '|'
  if (typeof err == 'string' && err.indexOf('|') > -1) {
    try {
      let errSplitArray = err.split('|');
      let errCode = errSplitArray[0];
      let dataDisplay = errSplitArray[1];
      let msg = APP.LANGUAGE.ServerErrors[errCode] || APP.LANGUAGE.Errors[errCode];
      if (msg) {
        msg = APP.LANGUAGE.ServerErrors[errCode].replace('##dataDisplay##', dataDisplay);
      }
      return msg;
    } catch (error) {
      console.error(error);
    }
  }
  // For any server error, first check if we have customise message, if not then show the general message.
  return APP.LANGUAGE.ServerErrors[err] || APP.LANGUAGE.Errors[err] || APP.LANGUAGE.ServerErrors.GeneralApiError;
};
